import { render, staticRenderFns } from "./TextModeLayout.vue?vue&type=template&id=7c8f20f4"
import script from "./TextModeLayout.vue?vue&type=script&lang=ts"
export * from "./TextModeLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports